import { Component, OnInit, Input } from '@angular/core';

import { InvestBbc } from '@classes/invest/invest-bbc/invest-bbc';

@Component({
    selector: 'app-bbc-eval',
    templateUrl: './bbc-eval.component.html',
    styleUrls: ['./bbc-eval.component.scss']
})
export class BbcEvalComponent implements OnInit {
    @Input() invest: InvestBbc;

    constructor() { }

    ngOnInit() {
    }

}
